<template>
  <BaseModal
    :modal-name="name"
    max-width="max-w-2xl"
    :close-button="false"
    @opened="onOpenedModal"
  >
    <div class="w-full">
      <h1 class="pb-3 text-2xl font-medium text-primary">
        {{ $t('share_doctor_consent.title') }}
      </h1>
      <div v-if="!isLoading" class="mt-10">
        <div
          v-for="doctor in authStore.getDoctorsAskingForConsent"
          :key="doctor.id"
          class="flex flex-col items-start md:pb-7"
        >
          <div>
            {{
              $t('share_doctor_consent.doctor_consent_description', {
                full_name: `${doctor.first_name} ${doctor.last_name}`,
              })
            }}
          </div>

          <div
            class="mt-4 flex w-full items-center justify-end space-x-8 text-sm md:justify-end"
          >
            <BaseButton
              theme="white"
              :disabled="isDisabledBtn"
              @click="onClickConfirm(doctor.id, false)"
            >
              {{ $t('action.reject') }}
            </BaseButton>

            <BaseButton
              type="button"
              theme="secondary"
              class="relative w-40 px-4 py-2"
              :disabled="isDisabledBtn"
              @click="onClickConfirm(doctor.id, true)"
            >
              {{ $t('action.accept') }}
            </BaseButton>
          </div>
        </div>
      </div>
      <div v-else class="space-y-5">
        <SkeletonsBase
          v-for="index in 2"
          :key="index"
          class="h-[100px] w-full"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { useAuthStore } from '~/stores/auth'
import { useModalsStore } from '~/stores/modals'

const name = 'consentDoctorsModal'
const authStore = useAuthStore()
const modalStore = useModalsStore()

const isLoading = ref(true)
const isDisabledBtn = ref(false)

const onOpenedModal = async () => {
  isLoading.value = true
  await authStore.fetchAccountData()

  if (authStore.getDoctorsAskingForConsent.length === 0) {
    modalStore.close(name)
  }
  isLoading.value = false
}

const onClickConfirm = async (id, isAccepted) => {
  isDisabledBtn.value = true

  await authStore.shareExaminationsForDoctor({ id, isAccepted })
  await authStore.fetchAccountData()

  if (authStore.getDoctorsAskingForConsent.length === 0) {
    modalStore.close(name)
  }
  isDisabledBtn.value = false
}
</script>
